import React, { useState } from "react";
import DomainUseCaseCard, { DOMAIN_PAGE_STYLES } from "./domainUseCaseLayout";
import AviationProcessFlow from "./AviationProcessFlow";
import UseCaseIndexGrid from "./UseCaseIndexGrid";
import DomainSeoHelmet from "./DomainSeoHelmet";
import DomainHiddenSeoContent from "./DomainHiddenSeoContent";

import {
  AVIATION_DOMAIN_INTRO,
  AVIATION_GROUPS,
  AVIATION_USE_CASES_SEO,
  AVIATION_DOMAIN_FAQS,
  AVIATION_ITEM_LIST_JSONLD,
  AVIATION_BREADCRUMB_JSONLD,
  AVIATION_WEBPAGE_JSONLD,
  AVIATION_FAQ_JSONLD,
} from "../../data/aviationUseCases";


function UseCaseCard({ useCase }) {
  return (
    <DomainUseCaseCard
      useCase={useCase}
      flow={<AviationProcessFlow useCaseId={useCase.id} />}
    />
  );
}

function GroupSection({ group }) {
  const cases = AVIATION_USE_CASES_SEO.filter((uc) => uc.groupId === group.id);
  if (!cases.length) return null;
  return (
    <section id={group.id} className="fin-section" aria-labelledby={`${group.id}-heading`}>
      <h2 id={`${group.id}-heading`}>{group.label}</h2>
      <div className="fin-list">{cases.map((uc) => <UseCaseCard key={uc.id} useCase={uc} />)}</div>
    </section>
  );
}

export default function AviationDomainContent() {
  const [activeFilter, setActiveFilter] = useState("all");
  const visibleGroups = activeFilter === "all" ? AVIATION_GROUPS : AVIATION_GROUPS.filter((g) => g.id === activeFilter);
  return (
    <div className="fin-page">
      <DomainSeoHelmet
        intro={AVIATION_DOMAIN_INTRO}
        domainSlug="aviation-domain"
        useCaseCount={AVIATION_USE_CASES_SEO.length}
        groupCount={AVIATION_GROUPS.length}
        itemListJsonLd={AVIATION_ITEM_LIST_JSONLD}
        breadcrumbJsonLd={AVIATION_BREADCRUMB_JSONLD}
        faqJsonLd={AVIATION_FAQ_JSONLD}
        webPageJsonLd={AVIATION_WEBPAGE_JSONLD}
      />
      <style>{DOMAIN_PAGE_STYLES}</style>
      <header className="fin-hero">
        <div className="fin-hero-inner">
          <h1>{AVIATION_DOMAIN_INTRO.title}</h1>
          {AVIATION_DOMAIN_INTRO.content ? <p>{AVIATION_DOMAIN_INTRO.content}</p> : null}
        </div>
      </header>
      <UseCaseIndexGrid useCases={AVIATION_USE_CASES_SEO} groups={AVIATION_GROUPS} heading="Aviation & Aerospace Use Cases" onFilterChange={setActiveFilter} />
      <div className="fin-wrap">{visibleGroups.map((group) => <GroupSection key={group.id} group={group} />)}</div>

      <DomainHiddenSeoContent
        domainTitle={AVIATION_DOMAIN_INTRO.title}
        domainFaqs={AVIATION_DOMAIN_FAQS}
        useCases={AVIATION_USE_CASES_SEO}
      />
    </div>
  );
}

